export class AdminInformationFindConditionViewModel {
    status = { label: "掲載中", value: 0 };
    target = null;
    targetName = "";
    subject = "";
    clear() {
        this.status = { label: "掲載中", value: 0 };
        this.target = null;
        this.targetName = "";
        this.subject = "";
    }
    copyFrom(condition) {
        this.status = condition.status;
        this.target = condition.target;
        this.targetName = condition.targetName;
        this.subject = condition.subject;
    }
    get summary() {
        let txt = "";
        if (this.status) {
            txt = `掲載状況:${this.status.label}`;
        }
        if (this.target) {
            txt += txt === "" ? "" : "、 ";
            txt += `掲載対象:${this.target.label}`;
        }
        if (this.targetName) {
            txt += txt === "" ? "" : "、 ";
            txt += `掲載対象名:${this.targetName}`;
        }
        if (this.subject) {
            txt += txt === "" ? "" : "、 ";
            txt += `タイトル:${this.subject}`;
        }
        return txt === "" ? "検索条件" : txt;
    }
}
